/**
 * The keys the backend sends beside an Adyen refusal (`errors[0].key`) and the widget text each
 * one is shown as. The backend adds keys without asking the widgets first, so a key missing here
 * is normal: the caller then keeps the text it showed before keys existed.
 */
export const ADYEN_ERROR_CONSTANTS = {
  BACKEND_KEYS: {
    BOOKING_REFUSED: 'adyen.booking_refused',
    SESSION_ALREADY_USED: 'adyen.session_already_used',
    /** The session's payment log expired before /book claimed it: nothing booked, money refunded. */
    SESSION_EXPIRED: 'adyen.session_expired',
    PAYMENT_UNAVAILABLE: 'adyen.payment_unavailable',
    NOT_ENABLED_FOR_BOOKING: 'adyen.not_enabled_for_booking',
  },
  MESSAGE_KEYS: {
    BOOKING_REFUSED: 'adyen.errors.booking_refused',
    UNAVAILABLE: 'adyen.errors.unavailable',
    TEMPORARILY_UNAVAILABLE: 'adyen.errors.temporarily_unavailable',
    SESSION_EXPIRED: 'adyen.errors.session_expired',
  },
  /** The notice beside a booking whose payment session the backend will not claim again. */
  SESSION_SPENT_NOTICE_KEY: 'payment_components.paymentSessionSpentNotice',
  /** The notice beside a refused session that the backend says already backs a confirmed booking. */
  ALREADY_BOOKED_NOTICE_KEY: 'payment_components.paymentAlreadyBookedNotice',
  /** `errors[0].params.already_booked` of a refused session: the booking it paid for exists. */
  ALREADY_BOOKED_PARAM: 'already_booked',
  /** The notice beside a paid booking still answered "booking lock" after every resend. */
  STILL_COMPLETING_NOTICE_KEY: 'payment_components.bookingStillCompletingNotice',
  /**
   * When a paid /book answered "booking lock" (HTTP 423) is sent again, in ms after that first
   * answer. The backend lock lives 10 s and is never released early, so the last resend falls
   * 2 s after it has certainly expired. The lock is usually held by this payment's own first
   * request, so a resend finds the booking.
   */
  BOOKING_LOCK_RESEND_AT_MS: [3000, 7000, 12000],
} as const;
